import { render, staticRenderFns } from "./labelValue.vue?vue&type=template&id=188e50bd"
import script from "./labelValue.vue?vue&type=script&lang=js"
export * from "./labelValue.vue?vue&type=script&lang=js"
import style0 from "./labelValue.vue?vue&type=style&index=0&id=188e50bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports